<div class="parent celo-content">
    <div class="header">
        <div class="title">Users with G2 review prompts enabled</div>
        <button mat-button class="celo-primary-button" (click)="openEnableDialog()">Enable prompts</button>
    </div>

    <!-- Table -->
    <div class="relative-table-container">
        <div *ngIf="isLoading" class="loading-shade">
            <app-empty-state></app-empty-state>
        </div>

        <div class="table-container">
            <table mat-table [dataSource]="dataSource" class="table">
                <ng-container matColumnDef="userId">
                    <th mat-header-cell *matHeaderCellDef>User ID</th>
                    <td mat-cell *matCellDef="let element">
                        <a [routerLink]="['/user/' + element.userId]">{{ element.userId }}</a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="promptsRemaining">
                    <th mat-header-cell *matHeaderCellDef>Prompts Remaining</th>
                    <td mat-cell *matCellDef="let element">{{ element.promptsRemaining }}</td>
                </ng-container>

                <ng-container matColumnDef="promptCount">
                    <th mat-header-cell *matHeaderCellDef>Prompts Shown</th>
                    <td mat-cell *matCellDef="let element">{{ element.promptCount }}</td>
                </ng-container>

                <ng-container matColumnDef="lastPromptedOnUtc">
                    <th mat-header-cell *matHeaderCellDef>Last Prompted</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.lastPromptedOnUtc ? (element.lastPromptedOnUtc | date: 'medium') : 'Never' }}
                    </td>
                </ng-container>

                <tr mat-header-row class="table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <div *ngIf="!isLoading && !dataSource?.length" class="no-results">
                - No users have G2 review prompts enabled -
            </div>
        </div>
    </div>

    <!-- Pagination -->
    <div class="paginator">
        <button class="load-more celo-tertiary-button" mat-button (click)="nextPage()" [disabled]="!hasNextPage">
            Load more >
        </button>
    </div>
</div>
